@if (store) {
<p class="s1 col-1">{{store.data?.store_name}}</p>
<p class="p1 col-11 m-t-1">{{store.data?.address}},</p>
<p class="p1 col-11">{{store.data?.city}}, {{store.data?.postcode}}</p>
<page-store-finder-store-status class="m-t-1"
                                [store]="store" />
}